<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="专题ID" :value="1"></el-option>
                            <el-option label="主题名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/operational/theme/saveTheme')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" size="small"
                @click="$router.push('/operation/special/add')">新增专题</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="id" label="专题ID"></el-table-column>
                <el-table-column prop="name" label="专题名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="activityNum" label="绑定演出数">
                    <template slot-scope="{row} = scope">
                        <router-link :to="`/operation/special/edit/step2/${row.id}`" class="color-theme">{{
                            row.activityNum }}</router-link>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="280">
                    <template slot-scope="{row} = scope">
                        <el-button v-if="$utils.have('/operational/theme/detail')" type="text" size="small"
                            @click="editStep1(row.id)">编辑</el-button>
                        <el-button v-if="$utils.have('/operational/theme/bindActivity')" type="text" size="small"
                            @click="editStep2(row.id)">绑定演出</el-button>
                        <el-button type="text" size="small" @click="view(row)">预览</el-button>
						<el-button type="text" size="small" @click="statistics(row.id)">专题数据</el-button>
                        <el-button v-if="$utils.have('/operational/theme/delete')" type="text" size="small" @click="del(row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <CodeView ref="codeView"></CodeView>
    </div>
</template>
<script>
import CodeView from '@/components/CodeView';
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: ""
}
export default {
    components: { CodeView },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
            },
            listLoading: true,
            sswap: process.env.VUE_APP_SSWAP_URL
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/operational/theme/list",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.data = null;
                        this.dataList = [];
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
		statistics(id){
			this.$router.push({
			    path: `/operation/special/statistics/${id}`,
			});
		},
        //编辑
        editStep1(id) {
            this.$router.push({
                path: `/operation/special/edit/step1/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        {
                            ...this.params,
                        }
                    ),
                },
            });
        },
        //绑定演出
        editStep2(id) {
            this.$router.push({
                path: `/operation/special/edit/step2/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        {
                            ...this.params,
                        }
                    ),
                },
            });
        },

        //预览
        view(item) {
            this.$refs.codeView.show({
                ...item,
				showWechart:1,
                // qrCodeUrl: item.activityHref
                qrCodeUrl: `${this.sswap}/pages/special/theme/index?id=${item.id}`
            })
        },
        //删除事件
        del(id){
                this.$confirm('确定要删除吗?', '提示', {
                    type: 'warning',
                    center: true,
                    closeOnClickModal: false
                }).then(() => {
                    this.listLoading = true;
                    this.$request({
                        url: '/operational/theme/delete',
                        method: 'POST',
                        params: {id:id}
                    }).then(res => {
                        const { state, msg } = res.data;
                        if( state == 1 ){
                            this.getDataList();
                        }else{
                            this.$message.error(msg || '请求失败');
                        }
                    }).catch(() => {
                        this.$message.error('请求错误');
                    }).finally(() => {
                        this.listLoading = false;
                    });
                })
            },
    }
}
</script>
<style lang="sass" scoped>

</style>